var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 66,
    viewBox: "0 0 120 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7 33.5L16.1 49.5H24.4L26.8 42.5H32.1V33.5H21.7Z",
    fill: "#FF000F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1 16.5H27.8L22.1 32.5H32.1V16.5Z",
    fill: "#FF000F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1 42.5H38.4L40.8 49.5H49.1L43.4 33.5H33.1V42.5Z",
    fill: "#FF000F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1 32.5L37.4 16.5H33.1V32.5H43.1Z",
    fill: "#FF000F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.3 32.5C99.3 31.1 97.9 30 96.4 29.2C98.2 27.9 99.4 25.8 99.4 23.5C99.4 19.6 96.3 16.5 92.4 16.5H90.1V32.5H100.3Z",
    fill: "#FF000F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1 33.5V49.5H91.8C97.7 49.5 102.3 44.7 102.3 38.8C102.3 36.9 101.9 35 101 33.5H90.1Z",
    fill: "#FF000F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1 16.5H79.1V32.5H89.1V16.5Z",
    fill: "#FF000F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1 33.5H79.1V49.5H89.1V33.5Z",
    fill: "#FF000F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3 32.5C72.3 31.1 70.9 30 69.4 29.2C71.2 27.9 72.4 25.8 72.4 23.5C72.4 19.6 69.3 16.5 65.4 16.5H63.1V32.5H73.3Z",
    fill: "#FF000F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 33.5V49.5H64.8C70.7 49.5 75.3 44.7 75.3 38.8C75.3 36.9 74.9 35 74 33.5H63.1Z",
    fill: "#FF000F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1 16.5H52.1V32.5H62.1V16.5Z",
    fill: "#FF000F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1 33.5H52.1V49.5H62.1V33.5Z",
    fill: "#FF000F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.75060c00.svg";
export { ForwardRef as ReactComponent };